/*
  ears
*/
/**
* Event Ears Management
*/
//-- set ears box height to max of document



setTimeout(function() {
  setEarsHeight();
  setEarsBg();
}, 1000);




function setEarsBg() {
  //==== set ears background using script output

  //-- get img element
  var ear_bg_img = $(".desk_event_ear_bg_script img");

  //-- set background
  if (ear_bg_img.length > 0) {
    $(".desk_event_ear").css("background", "url("+ear_bg_img.attr("src")+")");
  }
}


function setEarsHeight() {
  var __ears_minus_height = ($(".desktop-header").height() - $(".desk_breadcrumbs-1").outerHeight());
  if (PAGE_CODE === "hmp_in") {
    __ears_minus_height = __ears_minus_height + 250;
  }
  //var scrollHeight = document.body.scrollHeight;
  var docHeight = $(window).height();
  var mainHeight = $("main").height();
  var useHeight = 0;

  if (mainHeight < docHeight) {
    useHeight = docHeight;
  }
  else {
    useHeight = mainHeight;
  }

  useHeight = useHeight - __ears_minus_height;

  $(document).on("resize", function() {
    $(".desk_event_ear").css("height", useHeight);
  }).resize();
}
